import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Unity } from '../models/unity';

@Pipe({
  name: 'unity'
})
@Injectable({
  providedIn: 'root'
})
export class UnityPipe implements PipeTransform {

  transform(unity: Unity, type:'simple'|'complete' = 'complete'): any {
    if (unity)
      return type == 'complete' 
        ? "NE: " + unity.id + " - " + unity.unit_type.name + " " + unity.brand + " (" + unity.model + ") PL: " + unity.licence_plate
        : "NE: " + unity.id + " (" + unity.model + ") PL: " + unity.licence_plate;
    else 
      return "";
  }

}
